import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '../data/content';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('zd_lang') || 'es';
    }
    return 'es';
  });

  const changeLang = useCallback((l) => {
    setLang(l);
    if (typeof window !== 'undefined') localStorage.setItem('zd_lang', l);
  }, []);

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === 'es' ? 'zh' : 'es';
      if (typeof window !== 'undefined') localStorage.setItem('zd_lang', next);
      return next;
    });
  }, []);

  // translation helper: t('nav.home')
  const t = useCallback(
    (path) => {
      const parts = path.split('.');
      let node = translations[lang];
      for (const p of parts) {
        if (node == null) return path;
        node = node[p];
      }
      return node == null ? path : node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
}
